import React from 'react';
import { Box, Typography, Container, Divider } from '@mui/material';
import SimpleTimelineTest from '../components/SimpleTimelineTest';
import TimelineDemo from '../components/timeline/TimelineDemo';
import ProgressivePanelTest from '../components/timeline/ProgressivePanelTest';

const TimelineTestPage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Timeline UI Test Page
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          This page contains test components to verify the timeline functionality is working correctly.
        </Typography>
      </Box>

        <ProgressivePanelTest />
        
        <Divider sx={{ my: 4 }} />
        
        <SimpleTimelineTest />
        
        <Divider sx={{ my: 4 }} />
        
        <TimelineDemo />
    </Container>
  );
};

export default TimelineTestPage;
